// Dependencies
import styled, { css } from "styled-components";

// Utils
import { theme } from "config/theme";

type ContainerStyleProps = {
    isOpen: boolean;
};

export const Container = styled.div<ContainerStyleProps>`
    display: block;
    position: relative;

    .dropdown {
        width: 100% !important;
        max-height: 256px;

        position: absolute;
        transform: translateY(-4px);
        background-color: ${theme.colors.white};
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        z-index: 1;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;

        overflow-y: auto;
        scrollbar-width: thin;
        scrollbar-color: ${theme.colors.base[200]} ${theme.colors.base[100]};

        &::-webkit-scrollbar {
            width: 4px;
        }

        &::-webkit-scrollbar-track {
            background: ${theme.colors.base[100]};
        }

        &::-webkit-scrollbar-thumb {
            background-color: ${theme.colors.base[200]};
            border-radius: 20px;
        }

        ${({ isOpen }) =>
            !!isOpen &&
            css`
                width: 13.313em;
                right: -1px;
                opacity: 1;
                pointer-events: all;
                transform: translateY(4px);
            `}

        .webp-search-input {
            --webp-search-input-radius: 4px 4px 0 0;
        }
    }
`;
